import { createFileRoute } from '@tanstack/react-router';
import { ContactSection } from '../../components/contacts/ContactSection';

export const Route = createFileRoute('/_auth/customers')({
  component: () => <ContactSection contactType="customer" titlePlural="Customers" titleSingular="customer" />,
});
